class kukunButton {
    constructor(button_input, parameters) {
        this.element = button_input;
        this.button_params = parameters;
        this._addParameters();
        this._loadEvents();
    }

    _loadEvents() {
        if (this.element.children.length == 0) {
            this.element.innerHTML += this.loader
            this.element.children[0].style.display = "none"
        }
    }
    _addParameters() {
        this.loader = `
        <div class="k-btn-load">
            <span class="k-btn-loading-dot"></span>
            <span class="k-btn-loading-dot"></span>
            <span class="k-btn-loading-dot"></span>
            <span class="k-btn-loading-dot"></span>
        </div>
        `
    }
    start_loading() {
        this.element.classList.add('k-btn-loader')
    }
    stop_loading() {
        this.element.classList.remove('k-btn-loader')
    }
}

let buttonInstances = [];

const init = (button_input, button_params) => {
    if (button_input) {
        if (typeof button_input.length == 'undefined') {
            const htmlElement = button_input;
            const parameters = button_params;
            buttonInstances = new kukunButton(htmlElement, parameters);
        } else {
            for (let i = 0; i < button_input.length; i++) {
                const htmlElement = button_input[i];
                const parameters = button_params;
                let buttonInstance = new kukunButton(htmlElement, parameters);
                buttonInstances.push(buttonInstance);
            }
        }
    }
    return buttonInstances;
}

// const handlebuttonValue = (e) => {
//     console.log('handle: ', e)
// }

export {
    init
};